import React from "react";

export const FacebbokIcon = () => {
  return (
    <svg
      width="32"
      height="33"
      viewBox="0 0 32 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M29.3332 16.035C29.3332 8.67499 23.3598 2.70166 15.9998 2.70166C8.63984 2.70166 2.6665 8.67499 2.6665 16.035C2.6665 22.4883 7.25317 27.8617 13.3332 29.1017V20.035H10.6665V16.035H13.3332V12.7017C13.3332 10.1283 15.4265 8.03499 17.9998 8.03499H21.3332V12.035H18.6665C17.9332 12.035 17.3332 12.635 17.3332 13.3683V16.035H21.3332V20.035H17.3332V29.3017C24.0665 28.635 29.3332 22.955 29.3332 16.035Z"
        fill="#686677"
      />
    </svg>
  );
};
